<template>
  <v-card>
    <ValidationObserver ref="observer">
      <v-card-title>
        <span class="headline">{{ dialogTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <ValidationProvider name="numéro" rules="required" v-slot="{ errors }">
                <v-text-field
                  label="Numéro de série"
                  v-model="item.serial_number"
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <ValidationProvider name="modèle" rules="required" v-slot="{ errors }">
                <v-text-field
                  label="Modèle appareil"
                  v-model="item.model_name"
                  :error-messages="errors[0]"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                :close-on-content-click="false"
                v-model="menuManufacturing"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="manufacturingDateFormatted"
                    clearable
                    label="Date de fabrication"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="item.manufacturing_date"
                  first-day-of-week="1"
                  no-title
                  @change="menuManufacturing = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-select
                label="Client"
                v-model="item.client_id"
                :items="clients"
                item-text="name"
                item-value="client_id"
                no-data-text="Aucun client disponible"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                :close-on-content-click="false"
                v-model="menuInstallation"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="installationDateFormatted"
                    label="Date d'installation"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="item.installation_date"
                  first-day-of-week="1"
                  no-title
                  @change="menuInstallation = false">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                :close-on-content-click="false"
                v-model="menuRepair"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="repairDateFormatted"
                    label="Date de réparation"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="item.repair_date"
                  first-day-of-week="1"
                  no-title
                  @change="menuRepair = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Réparation"
                v-model="item.repair_comment"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                :close-on-content-click="false"
                v-model="menuTakingBack"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="takingBackDateFormatted"
                    label="Date de reprise"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="item.taking_back_date"
                  no-title
                  @change="menuTakingBack = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                :close-on-content-click="false"
                v-model="menuExchange"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="exchangeDateFormatted"
                    label="Date d'échange"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="item.exchange_date"
                  no-title
                  @change="menuExchange = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Tél. maintenance"
                v-model="item.operator_phone_number"
                hint="+33 06 12 34 56 78"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-text>
        {{ error }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dismiss">Annuler</v-btn>
        <v-btn color="blue darken-1" text @click="save">Sauver</v-btn>
      </v-card-actions>
    </ValidationObserver>
  </v-card>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { mapState } from 'vuex';

import { CLIENT_LIST } from '@/store/actions/client';
import { MACHINE_CREATE, MACHINE_UPDATE } from '@/store/actions/machine';


export default {
  name: 'MachineEdit',

  data () {
    return {
      menuManufacturing: false,
      menuInstallation: false,
      menuRepair: false,
      menuTakingBack: false,
      menuExchange: false,

      item: {},
      error: ''
    };
  },

  computed: {
    ...mapState({
      defaultItem: state => state.machine.defaultItem,
      clients: state => state.client.clients
    }),
    isNewItem () {
      return !this.item.machine_id;
    },
    dialogTitle () {
      return this.isNewItem ? 'Nouvel élément' : 'Edition';
    },
    manufacturingDateFormatted () {
      return this.formatDate(this.item.manufacturing_date);
    },
    installationDateFormatted () {
      return this.formatDate(this.item.installation_date);
    },
    repairDateFormatted () {
      return this.formatDate(this.item.repair_date);
    },
    takingBackDateFormatted () {
      return this.formatDate(this.item.taking_back_date);
    },
    exchangeDateFormatted () {
      return this.formatDate(this.item.exchange_date);
    }
  },

  created () {
    this.reset();
  },

  mounted () {
    this.$store.dispatch(CLIENT_LIST);
  },

  methods: {
    edit (_item) {
      this.item = _.merge({}, this.item, this.defaultItem, _item);
    },

    reset () {
      this.item = _.merge({}, this.item, this.defaultItem);
      this.error = '';

      requestAnimationFrame(() => {
        this.$refs.observer.reset();
      });
    },

    dismiss () {
      this.$emit('dismissed');
      this.reset();
    },

    formatDate (date) {
      if (!date) {
        return '';
      }

      return moment(date).format('L');
    },

    async save () {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }

      // Send to Store
      try {
        if (this.isNewItem) {
          await this.$store.dispatch(MACHINE_CREATE, this.item);
        } else {
          await this.$store.dispatch(MACHINE_UPDATE, this.item);
        }
      } catch (err) {
        this.error = err;
        return;
      };

      // Close
      this.$emit('saved');

      // Reset the values
      this.reset();
    }
  }
};
</script>
